import { BusinessHoursPeriod, TimeSlot } from '../../graphql/schema';

// enums
enum DateWorkingMode {
  START = 'start',
  END = 'end',
}

// types
type CalendarPeriodOption = {
  value: CalendarPeriodOptionValue;
  text: string;
};

type CalendarPeriodOptionValue = {
  label?: string;
  available: boolean;
  end: string;
  periodId: string;
  start: string;
};

type DayAvailability = { closed: boolean; disabled: boolean };

type DatesAvailabilityType = {
  availableDates: string[] | undefined;
  closedDates: string[] | undefined;
};

// interfaces
interface DateRangeMode {
  start?: Date;
  end?: Date;
}

interface Day {
  datetime: string;
  text: string;
  value: Date;
  enabled: boolean;
  // represents a day of a previous or next month that is enabled
  enabledNotInMonth: boolean;
  disabledNotInMonth: boolean;
  selected: boolean;
  inBetween: boolean;
  closed: boolean;
  currentDay: boolean;
}

interface RangeSchedules {
  start: BusinessHoursPeriod;
  end: BusinessHoursPeriod;
}

interface TestDriveDay {
  available: boolean;
  dealerOpen: boolean;
  requestTimeSlots?: TimeSlot[];
  date: string;
}

// returning types for classes
interface CalendarDayClasses {
  'otb-calendar-day--start-boundary': boolean;
  'otb-calendar-day--end-boundary': boolean;
  'otb-calendar-day--no-control': boolean;
  'otb-calendar-day--within-range': boolean;
  'otb-calendar-day--closed-dealer': boolean;
  'otb-calendar-day--weekend': boolean;
}

interface CalendarTimeClasses {
  'wb-type-hint-strong': boolean;
  'otb-calendar-day--closed': boolean;
  'otb-calendar-day--unavailable': boolean;
  'otb-calendar-day--pre-available': boolean;
  'otb-calendar-day--current wb-type-hint-strong': boolean;
  'otb-calendar-day--not-in-month-unavailable': boolean;
}

// returning types for style
interface GridTemplateColumns {
  'grid-template-columns'?: string;
}

export {
  // enums
  DateWorkingMode,
  // types
  CalendarPeriodOption,
  CalendarPeriodOptionValue,
  DayAvailability,
  DatesAvailabilityType,
  // interfaces
  DateRangeMode,
  Day,
  RangeSchedules,
  TestDriveDay,
  // returning types for classes
  CalendarDayClasses,
  CalendarTimeClasses,
  // returning types for style
  GridTemplateColumns,
};
